<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New Testimony
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-form-group
            label="Avatar"
            label-for="avatar"
          >
            <b-img :src="userData.avatars" style="max-width: 200px"></b-img>
            <input
              class="form-control"
              ref="refInputEl"
              type="file"
              @input="inputImageRenderer"
              @change="imageOnUpload"
              required
              autofocus
            >
          </b-form-group>

          <!-- Type -->
          <validation-provider
            #default="validationContext"
            name="Type"
            rules="required"
          >
            <b-form-group
              label="Type"
              label-for="type"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{label: 'Buyer', value: 1}, {label: 'Seller', value: 2}]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="type"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="name"
              :state="getValidationState(validationContext)"
            >
              <b-form-input
                id="name"
                v-model="userData.name"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Group Name -->
          <validation-provider
            #default="validationContext"
            name="Group Name English"
            rules="required"
          >
            <b-form-group
              label="Group Name English"
              label-for="groupName"
            >
              <b-form-input
                id="groupName"
                v-model="userData.groupNameEn"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Review -->
          <validation-provider
            #default="validationContext"
            name="Review"
            rules="required"
          >
            <b-form-group
              label="Review English"
              label-for="reviewEn"
              :state="getValidationState(validationContext)"
            >
              <b-form-textarea
                id="reviewEn"
                v-model="userData.reviewEn"
                debounce="500"
                rows="3"
                max-rows="5"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Description -->
          <validation-provider
            #default="validationContext"
            name="Description"
            rules="required"
          >
            <b-form-group
              label="Description English"
              label-for="descriptionEn"
              :state="getValidationState(validationContext)"
            >
              <quill-editor
                v-model="userData.descriptionEn"
                :options="editorOption"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <hr>

          <!-- Group Name -->
          <validation-provider
            #default="validationContext"
            name="Group Name Indonesia"
            rules="required"
          >
            <b-form-group
              label="Group Name Indonesia"
              label-for="groupName"
            >
              <b-form-input
                id="groupName"
                v-model="userData.groupNameId"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Review -->
          <validation-provider
            #default="validationContext"
            name="Review"
            rules="required"
          >
            <b-form-group
              label="Review Indonesia"
              label-for="reviewEn"
              :state="getValidationState(validationContext)"
            >
              <b-form-textarea
                id="reviewId"
                v-model="userData.reviewId"
                debounce="500"
                rows="3"
                max-rows="5"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Description -->
          <validation-provider
            #default="validationContext"
            name="Description Indonesia"
            rules="required"
          >
            <b-form-group
              label="Description Indonesia"
              label-for="descriptionId"
              :state="getValidationState(validationContext)"
            >
              <quill-editor
                v-model="userData.descriptionId"
                :options="editorOption"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Add
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormTextarea, BImg
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormTextarea,
    BImg,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

    quillEditor,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
      editorOption: {
        theme: 'snow',
      },
    }
  },
  setup(props, { emit }) {
    const toast = useToast()
    const refInputEl = ref(null)
    const blankEventData = {
      avatar: '',
      avatars: '',
      type: '',
      name: '',
      groupNameEn: '',
      reviewEn: '',
      descriptionEn: '',
      groupNameId: '',
      reviewId: '',
      descriptionId: '',
    }

    const userData = ref(JSON.parse(JSON.stringify(blankEventData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankEventData))
    }

    const imageOnUpload = (event, callback) => {
      userData.value.avatar = event.target.files[0]
    };

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      userData.value.avatars = base64
    })

    const onSubmit = () => {
      const formData = new FormData()

      formData.append('avatar', userData.value.avatar)
      formData.append('type', userData.value.type)
      formData.append('name', userData.value.name)
      formData.append('groupNameEn', userData.value.groupNameEn)
      formData.append('reviewEn', userData.value.reviewEn)
      formData.append('descriptionEn', userData.value.descriptionEn)
      formData.append('groupNameId', userData.value.groupNameId)
      formData.append('reviewId', userData.value.reviewId)
      formData.append('descriptionId', userData.value.descriptionId)

      store.dispatch('app-testimony/addTestimony', formData).then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Testimony successfully added!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        emit('refetch-data')
        emit('update:is-add-new-user-sidebar-active', false)
      }).catch((err) => {
        if (err.response.data.code == 422) {
          toast({
            component: ToastificationContent,
            props: {
              title: err.response.data.data[0].message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }else {
          toast({
            component: ToastificationContent,
            props: {
              title: "Something's Wrong, please try again!",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,

      inputImageRenderer,
      imageOnUpload,
      refInputEl,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
